import { render, staticRenderFns } from "./DeleteApportionmentModal.vue?vue&type=template&id=49a9eb42"
import script from "./DeleteApportionmentModal.vue?vue&type=script&lang=js"
export * from "./DeleteApportionmentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports